import React, {useState, useEffect} from 'react';
import {FiBookOpen, FiEdit2, FiLogOut, FiMusic, FiPlus, FiTrash2, FiUser} from 'react-icons/fi';
import {Link, useHistory, useParams} from 'react-router-dom';

import api from '../../services/api';
import {logout} from '../../auth/auth';
import urlBackend from '../../config-backend'

import {StoryAggregate} from '../../dtos/StoryAggregate';
import {confirmAlert} from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import logo from '../../assets/fullLogo.png';
import './styles.css';

function StoryDetails() {
    const [story, setStory] = useState<StoryAggregate>({title: '', image: '', audio: '', mouths: []});
    const {id} = useParams();

    const history = useHistory();

    useEffect(() => {
        api.get(`/stories/${id}`).then((response) => {
            setStory(response.data);
        });
    }, [id]);

    async function handleLogout() {
        logout();
        history.push('/');
    }

    async function handleDelete() {
        confirmAlert({
            title: 'Confirmação de exclusão',
            message: 'Você realmente quer excluir esta história?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        api.delete(`/stories/${id}`).then((response) => {
                            setStory(response.data);
                            history.push('/list/story');
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => {
                    }
                }
            ]
        });

    }

    return (
        <div id="page-create-point">
            <header className={'menu'}>
                <img src={logo} alt="Miaw" width={136}/>
                <nav id="menu">
                    <Link to="/list/story">
                        <FiBookOpen/>
                        Minhas histórias
                    </Link>
                    <Link to="/new/story">
                        <FiPlus/>
                        Adicionar história
                    </Link>
                    <a href="#" rel="noopener noreferrer" onClick={handleLogout}>
                        <FiLogOut/>
                        Sair
                    </a>
                </nav>
            </header>
            <main id="story-details">
                <div className="flex details-header">
                    <h1>{story.title}</h1>
                    <div style={{marginTop: 16}}>
                        <button type="button" onClick={handleDelete}
                                style={{background: 'transparent', border: 0, borderRadius: 8, cursor: 'pointer'}}>
                            <FiTrash2 size={24} color="#80e0d6"/>
                        </button>
                        <Link to={`/edit/story/${id}`} style={{marginLeft: 8}}>
                            <FiEdit2 size={24} color="#fcab75"/>
                        </Link>
                    </div>
                </div>
                <div className="flex">
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <img src={`${urlBackend}/uploads/${story.image}`} className="circle" alt={story.image}
                             width={120}
                             height={120}/>
                        <p><FiUser/> {story.user?.name}</p>
                        <p><FiMusic/> {story.audio?.slice(story.audio?.indexOf('-') + 1)}</p>
                    </div>
                    <div className="grid-mouths">
                        {story.mouths?.map(mouth => (
                            <img
                                key={mouth.image}
                                src={`${urlBackend}/uploads/icons-mouths/${mouth.image}`}
                                alt={mouth.image}
                                width={150}
                            />
                        ))}
                    </div>
                </div>
            </main>
        </div>
    );
}

export default StoryDetails;
